'use strict'

/*
 * Functions that are needed in both Add.js and Detail.js for the Patient views should be added here
 *
 * NOTES: When writing a new function or moving a function here, assume that this function has NO ACCESS TO GLOBAL VARIABLES/FUNCTIONS!
 */
window.SharedPatientFunctions = {
    setAutocompletePhysician: function (isLoading, appType, viewbag, data, response) {
        const longAppType = {GP: 'GeneralPractitioner', EP: 'ExtraPhysician'}[appType];
        const inputFieldID = "#" + longAppType + "ID";
        setAutocompleteInputLoading(isLoading, $(inputFieldID));

        if(isLoading) return;

        const inputFieldText = "#" + longAppType + "Text";
        const detailLink = "a#show" + appType + "Detail" + viewbag;
        const removeLink = "a#remove" + appType + viewbag;
        
        let physicians = data.physicians;
        if (physicians.length === 0) {
            $(inputFieldID).val("");
            $(detailLink).addClass('inActive');
            $(removeLink).addClass('inActive');
            $(inputFieldText).css('border-color', '#CD0A0A');
        }
        setPhysicianAutocompleteResults(data, response);
    },
};
